import { render } from "./stateDetail.vue?vue&type=template&id=5d8ef2b4&scoped=true&ts=true"
import script from "./stateDetail.vue?vue&type=script&lang=ts&config=true"
export * from "./stateDetail.vue?vue&type=script&lang=ts&config=true"

import "./stateDetail.vue?vue&type=style&index=0&id=5d8ef2b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8ef2b4"]])

export default __exports__